import React from 'react';
import {remCss, scssVariables as variables} from 'src/helpers';

const ChartIcon = React.memo(
    ({pathFill = variables['colors-mc-text-primary'], width = 40}) => (
        <svg
            id="trafic"
            xmlns="http://www.w3.org/2000/svg"
            width={remCss(width)}
            height={remCss(width)}
            viewBox="0 0 40 40"
        >
          <path opacity="0.3" d="M18.125 18.125H21.875V31.25H18.125V18.125Z"
                fill={pathFill}/>
          <path
              d="M12.5 25.625H8.75V31.25H12.5V25.625ZM21.875 18.125H18.125V31.25H21.875V18.125ZM31.25 8.75V31.25H27.5V8.75H31.25ZM27.5 6.875C27.0027 6.875 26.5258 7.07254 26.1742 7.42417C25.8225 7.77581 25.625 8.25272 25.625 8.75V31.25C25.625 31.7473 25.8225 32.2242 26.1742 32.5758C26.5258 32.9275 27.0027 33.125 27.5 33.125H31.25C31.7473 33.125 32.2242 32.9275 32.5758 32.5758C32.9275 32.2242 33.125 31.7473 33.125 31.25V8.75C33.125 8.25272 32.9275 7.77581 32.5758 7.42417C32.2242 7.07254 31.7473 6.875 31.25 6.875H27.5ZM16.25 18.125C16.25 17.6277 16.4475 17.1508 16.7992 16.7992C17.1508 16.4475 17.6277 16.25 18.125 16.25H21.875C22.3723 16.25 22.8492 16.4475 23.2008 16.7992C23.5525 17.1508 23.75 17.6277 23.75 18.125V31.25C23.75 31.7473 23.5525 32.2242 23.2008 32.5758C22.8492 32.9275 22.3723 33.125 21.875 33.125H18.125C17.6277 33.125 17.1508 32.9275 16.7992 32.5758C16.4475 32.2242 16.25 31.7473 16.25 31.25V18.125ZM6.875 25.625C6.875 25.1277 7.07254 24.6508 7.42417 24.2992C7.77581 23.9475 8.25272 23.75 8.75 23.75H12.5C12.9973 23.75 13.4742 23.9475 13.8258 24.2992C14.1775 24.6508 14.375 25.1277 14.375 25.625V31.25C14.375 31.7473 14.1775 32.2242 13.8258 32.5758C13.4742 32.9275 12.9973 33.125 12.5 33.125H8.75C8.25272 33.125 7.77581 32.9275 7.42417 32.5758C7.07254 32.2242 6.875 31.7473 6.875 31.25V25.625Z"
              fill={pathFill}/>

        </svg>
    ),
);
ChartIcon.displayName = 'ChartIcon';

export default ChartIcon;
